<template>
  <DeleteConfirm
      itemKey="IndexGroup"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import IndexGroups from '@/services/index-groups'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return IndexGroups
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť skupinu "' + Item.title + '"'
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť skupinu číselníkov "' + Item.title + '"?'
      },
      deleteData() {
        return IndexGroups
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
